<template>
  <IdeaActivityNotification
    :notification="notification"
    title="Idea promoted to Roadmap Feature"
  >
    <template #pic>
      <div class="label-pic is-yellow">
        <icon
          data="@icon/link-on.svg"
          class="label-pic__icon idea-activity-promoted__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
  </IdeaActivityNotification>
</template>

<script setup lang="ts">
import IdeaActivityNotification from "@/components/Notification/components/IdeaActivityNotification.vue"

import { NotificationIdeaActivity } from "@/models/Notification"

defineProps<{
  notification: NotificationIdeaActivity
}>()
</script>

<style lang="scss" scoped>
.idea-activity-promoted__icon {
  :deep(path) {
    fill: var(--markingYellow-03);
  }
}
</style>
